export enum MessageType {
    info = 'info', error = 'error', success = 'success'
}